import { LayoutService } from './../../../services/layout.service';
import { TemplatePortalDirective, Portal } from '@angular/cdk/portal';
import { OverlayOrigin, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, Renderer2, Input } from '@angular/core';
import { fadeUp, ringing } from '../../../animations/router.animation';
export class MainToolbarNotificationComponent implements OnInit {

     menu: OverlayOrigin;
     shake: ElementRef;
     blink = false;
     templatePortals: QueryList<Portal<any>>;
/**
 * @param {?} overlay
 * @param {?} _render
 * @param {?} _layout
 */
constructor(
public overlay: Overlay,
private _render: Renderer2,
private _layout: LayoutService
    ) { }
/**
 * @return {?}
 */
ngOnInit() {
        this._layout.showNotification.subscribe(res => {
            if (res) {
                this.blink = true;
                this._render.addClass(this.shake.nativeElement, 'm-animate-shake');
            } else {
                this.blink = false;
                this._render.removeClass(this.shake.nativeElement, 'm-animate-shake');
            }
        });
    }
/**
 * @param {?} e
 * @return {?}
 */
clickMenu(e) {
        this.blink = false;
        this._render.removeClass(this.shake.nativeElement, 'm-animate-shake');
        const /** @type {?} */ config = new OverlayConfig({
            hasBackdrop: true,
            backdropClass: 'menu-overlay-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.block(),
            positionStrategy: this.overlay.position().connectedTo(
                this.menu.elementRef,
                {originX: 'center', originY: 'bottom'},
                {overlayX: 'center', overlayY: 'top'}
            ).withOffsetX(-30)
        });
        const /** @type {?} */ overlayRef = this.overlay.create(config);
        overlayRef.attach(this.templatePortals.first);
        overlayRef.backdropClick().subscribe(() => {
            overlayRef.dispose();
        });
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[hd-main-toolbar-notification]',
  template: `
    <a cdk-overlay-origin class="right-menu-item-link" #notification="cdkOverlayOrigin" (click)="clickMenu($event)">
        <span *ngIf='blink' class="notification-dot-blink m-animate-blink"></span>
        <span #shake class="right-menu-link-icon">
            <i class="flaticon-music-2"></i>
        </span>
    </a>
    <ng-template cdk-portal>
        <div class="notification-dropdown" [@fadeUp]="">
            <span class="arrow" style="left: 58%"></span>
            <div class="inner">
                <div class="header" style="background: url(./assets/notification.jpg); background-size: cover;">
                    <span class="header-title">
                        9 New
                    </span>
                    <span class="header-subtitle">
                        User Notifications
                    </span>
                </div>
                <ng-content></ng-content>
            </div>
        </div>
    </ng-template>
  `,
  styles: [`
    :host {
      padding: 0 12px;
      height: 100%;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      font-size: 14px;
      font-weight: 300;
      font-family: "Poppins";
      -webkit-font-smoothing: antialiased;
      line-height: 1.5;
      color: #212529;
      background-color: #fff; }

    .right-menu-item-link {
      position: relative;
      margin: 0 auto;
      width: auto;
      padding: 9px 0;
      display: table;
      table-layout: fixed;
      height: 100%;
      text-decoration: none;
      outline: none !important;
      vertical-align: middle;
      -ms-touch-action: manipulation;
          touch-action: manipulation;
      color: #5867dd;
      background-color: transparent;
      cursor: auto;
      padding: 0;
      margin: 0;
      list-style: none;
      height: 100%;
      margin: 0px;
      padding: 0px;
      font-size: 14px;
      font-weight: 300;
      font-family: "Poppins";
      cursor: pointer; }
      .right-menu-item-link .right-menu-link-icon {
        text-align: center;
        line-height: 0;
        vertical-align: middle;
        padding: 0;
        color: #ad5beb;
        display: table-cell;
        height: 100%;
        width: 35px;
        font-size: 1.4rem;
        -webkit-animation-fill-mode: initial;
                animation-fill-mode: initial;
        text-decoration: none;
        background-color: transparent;
        height: 100%;
        margin: 0px;
        padding: 0px;
        font-weight: 300;
        font-family: "Poppins";
        -ms-text-size-adjust: 100%;
        -webkit-font-smoothing: antialiased; }
      .right-menu-item-link i {
        font-size: 1.5rem; }
      .right-menu-item-link i:before {
        font-weight: bold;
        padding: 1px;
        background: -webkit-gradient(linear, left top, left bottom, color-stop(25%, #ad5beb), color-stop(50%, #c678db), color-stop(75%, #da6ea9), to(#e76e92));
        background: linear-gradient(180deg, #ad5beb 25%, #c678db 50%, #da6ea9 75%, #e76e92 100%);
        background-clip: text;
        text-fill-color: transparent;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent; }

    [class^="flaticon-"]:before, [class*=" flaticon-"]:before {
      font-family: Flaticon;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      line-height: 1;
      text-decoration: inherit;
      text-rendering: optimizeLegibility;
      text-transform: none;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
      font-smoothing: antialiased; }

    .notification-dot-blink {
      left: 50%;
      margin-left: -2px;
      position: absolute;
      top: 11px;
      background-color: #f4516c;
      color: #ffffff;
      padding: 0;
      line-height: 4px;
      min-height: 4px;
      min-width: 4px;
      height: 4px;
      width: 4px;
      border-radius: 100%;
      -webkit-animation-fill-mode: initial;
              animation-fill-mode: initial; }

    @-webkit-keyframes m-animate-blink {
      50% {
        opacity: 0.0; } }

    @keyframes m-animate-blink {
      50% {
        opacity: 0.0; } }

    @-webkit-keyframes m-animate-shake {
      from {
        -webkit-transform: rotate(13deg);
        transform: rotate(13deg); }
      to {
        -webkit-transform-origin: center center;
        -webkit-transform: rotate(-13deg);
        transform: rotate(-13deg); } }

    @keyframes m-animate-shake {
      from {
        -webkit-transform: rotate(13deg);
        transform: rotate(13deg); }
      to {
        -webkit-transform-origin: center center;
        -webkit-transform: rotate(-13deg);
        transform: rotate(-13deg); } }

    .m-animate-blink {
      -webkit-animation: m-animate-blink 1s step-start 0s infinite;
      animation: m-animate-blink 1s step-start 0s infinite;
      -webkit-animation-fill-mode: initial;
              animation-fill-mode: initial; }

    .m-animate-shake {
      -webkit-animation: m-animate-shake 0.1s ease-in 0.1s infinite alternate;
      animation: m-animate-shake 0.1s ease-in 0.1s infinite alternate;
      -webkit-animation-fill-mode: initial;
              animation-fill-mode: initial; }
  `],
  animations: [fadeUp(), ringing()]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Overlay, },
{type: Renderer2, },
{type: LayoutService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menu': [{ type: ViewChild, args: ['notification', ] },],
'shake': [{ type: ViewChild, args: ['shake', ] },],
'blink': [{ type: Input },],
'templatePortals': [{ type: ViewChildren, args: [TemplatePortalDirective, ] },],
};
}

function MainToolbarNotificationComponent_tsickle_Closure_declarations() {
/** @type {?} */
MainToolbarNotificationComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MainToolbarNotificationComponent.ctorParameters;
/** @type {?} */
MainToolbarNotificationComponent.propDecorators;
/** @type {?} */
MainToolbarNotificationComponent.prototype.menu;
/** @type {?} */
MainToolbarNotificationComponent.prototype.shake;
/** @type {?} */
MainToolbarNotificationComponent.prototype.blink;
/** @type {?} */
MainToolbarNotificationComponent.prototype.templatePortals;
/** @type {?} */
MainToolbarNotificationComponent.prototype.overlay;
/** @type {?} */
MainToolbarNotificationComponent.prototype._render;
/** @type {?} */
MainToolbarNotificationComponent.prototype._layout;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
